module.exports = __webpack_public_path__ + "static/media/Piechart.7d9926ca.svg";